import React, { useMemo } from 'react';
import { observer } from 'mobx-react';
import dayjs from 'dayjs';

import { publicationRegisterStore } from '@stores/publicationRegisterStore';
import { addZeroToDate } from '@utils';

import styles from '../PublicationRegisterDrawer.module.scss';

export const PackageInfo = observer(() => {
  const { reportPackageInfo } = publicationRegisterStore;

  const packageExpansionDate = `${addZeroToDate(reportPackageInfo.dueDay)}.${addZeroToDate(
    reportPackageInfo.disclosureMonthCode,
  )}.${reportPackageInfo.reportPackageYear ?? ''}`;

  const packagePreparationDate = useMemo(() => {
    const period = reportPackageInfo.calendar?.find(
      (item) =>
        item.dueDay === reportPackageInfo.dueDay && item.disclosureMonthCode === reportPackageInfo.disclosureMonthCode,
    );
    return `${addZeroToDate(period?.preparationDay)}.${addZeroToDate(period?.preparationMonthCode)}.${
      reportPackageInfo.reportPackageYear ?? ''
    }`;
  }, [
    reportPackageInfo.calendar,
    reportPackageInfo.disclosureMonthCode,
    reportPackageInfo.dueDay,
    reportPackageInfo.reportPackageYear,
  ]);

  return (
    <>
      <p className={styles.subtitle}>Информация о пакете</p>
      <ul className={styles.list}>
        <li>
          Описание пакета: <span>{reportPackageInfo.reportPackageDescription}</span>
        </li>
        <li>
          Статус: <span>{reportPackageInfo.reportPackageStatus}</span>
        </li>
        <li>
          Дата раскрытия пакета: <span>{packageExpansionDate}</span>
        </li>
        <li>
          Дата подачи пакета: <span>{packagePreparationDate}</span>
        </li>
        <li>
          Дата создания пакета:{' '}
          <span>
            {reportPackageInfo.buildDate ? dayjs(new Date(reportPackageInfo.buildDate)).format('DD.MM.YYYY') : ''}
          </span>
        </li>
      </ul>
    </>
  );
});
